import News from './News';

export default News;



// WEBPACK FOOTER //
// ./src/components/Buildings/News/index.js